import { render, staticRenderFns } from "./CoachImporter.vue?vue&type=template&id=b8e402cc"
import script from "./CoachImporter.vue?vue&type=script&lang=ts"
export * from "./CoachImporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports